import React from 'react';
import {
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

import LandingToolBar from '../Landing/LangingToolBar';
import StorageFactory from '../../Util/StorageFactory';
import { SESSION_USER_ID_KEY } from '../../Util/VMConstants';
import { isEmpty, toTitleCase } from '../../Util/UtilHelper';
import MUITypography from '../../Components/MUITypography';

function VMLandingAboutUs() {
  const sessionFactory = new StorageFactory('session');
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);

  const cardBase = {
    height: '100%',
    borderRadius: 4,
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <Box component="section">
      {isEmpty(userID) && <LandingToolBar />}

      {/* Banner */}
      <Box
        component="img"
        src="/static/about_us.svg"
        alt="About Us"
        sx={{ width: '100%',height:'400px', display: 'block', objectFit: 'cover' }}
      />

      {/* GRID LAYOUT */}
      <Box
        px={{ xs: 2, sm: 4, md: 8 }}
        py={6}
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 1fr',
          },
          gap: 4,
        }}
      >
        {/* About Us */}
        <Card sx={{ ...cardBase, backgroundColor: '#f3fbfd' }}>
          <CardContent>
            <MUITypography variant="h4" fontWeight="bold" textAlign="center" mb={2}>
              About Us
            </MUITypography>
            <MUITypography textAlign="center" >
                {toTitleCase("Venue management offer a comprehensive application tailored for sales executives in the hospitality industry. Our platform enables sales professionals to efficiently manage venue details, customer bookings, follow-ups and subscription services seamlessly with user friendly features and advanced functionalities, venue management empowers sales teams to streamline their operations and enhance customer service.")}
            </MUITypography>
          </CardContent>
        </Card>

        {/* Our Mission */}
        <Card sx={{ ...cardBase, backgroundColor: '#fff4e8' }}>
          <CardContent>
            <MUITypography variant="h4" fontWeight="bold" textAlign="center" mb={2}>
              Our Mission
            </MUITypography>
            <MUITypography textAlign="center" color="text.secondary">
              {toTitleCase("To simplify and automate event venue management—reducing manual work, minimizing errors, and enabling smarter decisions through real-time data.")}
            </MUITypography>
          </CardContent>
        </Card>

        {/* Our Vision */}
        <Card sx={{ ...cardBase, backgroundColor: '#fff4e8' }}>
          <CardContent>
            <MUITypography variant="h4" fontWeight="bold" textAlign="center" mb={2}>
              Our Vision
            </MUITypography>
            <MUITypography textAlign="center" color="text.secondary">
              {toTitleCase("To become the most trusted global solution for event venue management, empowering venues with technology that improves efficiency, enhances communication, and supports long-term business growth.")}
            </MUITypography>
          </CardContent>
        </Card>

        {/* Why Us */}
        <Card sx={{ ...cardBase, backgroundColor: '#f3fbfd' }}>
          <CardContent>
            <MUITypography variant="h4" fontWeight="bold" textAlign="center" mb={2}>
              Why Us?
            </MUITypography>
            <List dense>
              {[
                'Easy And Organized Enquiry & Booking Management',
                'Invoice Billing, Payments, And Reminders',
                'Centralized Dashboard For Venue Oversight',
                'Multi-Venue & Multi-Branch Support',
                'Customer Communication & CRM tools',
                'Reports & Analytics',
                'Cloud-Based Access',
                'Reliable Support',
              ].map((item, i) => (
                <ListItem key={i} disablePadding>
                  <ListItemText primary={`• ${item}`} />
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default VMLandingAboutUs;
